import React from "react";
export default function SubContenidoTemario({vNumSeccion = "", vTituloSeccion = "", vContenidoSeccion = ""}) {
  
  console.log(vContenidoSeccion)
  return  <>
  <div data-figma-id="4372:18330" class="temario-seccion-2">
    <div data-figma-id="4372:18331" class="temario-seccion-numero-2">
      <p data-figma-id="4372:18332" class="temario-seccion-numero-texto-2">
        {vNumSeccion}
      </p>
    </div>
    <div data-figma-id="4372:18333" class="frame-289784">
      <p
        data-figma-id="4372:18334"
        class="qu-es-la-ciencia-de-datos-en-las-finanzas"
      >
        {vTituloSeccion}
      </p>
      <p
        data-figma-id="4372:18335"
        class="qu-significa-y-abarca-la-ciencia-de-datos-en-las-finanzas"
      >
        {vContenidoSeccion}
      </p>
    </div>
  </div>

  <div data-figma-id="4372:18336" class="temario-linea-divisora"></div>
</>;

}
